export default __webpack_public_path__ + "static/media/inner-course-symb.b38bc3af.svg";